<div class="timesheet-info">


  <ng-template [ngIf]="hasBreak1Info()"><div class="hourCell" [ngStyle]="line.break1Validation.style()">
    <ng-template #break1>
      <ng-template [ngIf]="!line.break1Validation.isSuccess()"><ul>
        <li *ngFor="let msg of line.break1Validation.messages">
          {{msg}}
        </li>
      </ul></ng-template>
    </ng-template>


    <ng-template [ngIf]="!line.break1Validation.isSuccess()"><div style="float:right;"  placement="top" [ngbPopover]='break1' triggers="mouseenter:mouseleave">
      <i class="fa fa-exclamation-triangle"></i>
    </div></ng-template>

    <ng-template #ep1>
      <div [innerHtml] = "explainBreak1()"></div>
    </ng-template>

    <div style="float: left;" placement="top" [ngbPopover]='ep1' triggers="mouseenter:mouseleave">
      <i style="font-size: small;" class="fa fa-info"></i>
    </div>




    <div class="zoomable">
      <div class="hourCell-main">
        - {{retrieveBreak1() | displayMinute}}
      </div>
      <ng-template [ngIf]="hasBreak1Info()"><div class="hourCell-bottom">
        <div class="hourCell-bottom-left">
          {{currentEmployeeHoraire.sdBreak1Start | myDateFormat:'LT'}}
        </div>

        <div class="hourCell-bottom-right">
          {{currentEmployeeHoraire.tsBreak1StartPunchDt | myDateFormat:'LT':'xx:xx'}}-{{currentEmployeeHoraire.tsBreak1EndPunchDt | myDateFormat:'LT':'xx:xx'}}
        </div>
      </div></ng-template>
    </div>

  </div></ng-template>



  <ng-template [ngIf]="hasBreak2Info()"><div class="hourCell" [ngStyle]="line.break2Validation.style()">

    <ng-template #break2>
      <ng-template [ngIf]="!line.break2Validation.isSuccess()"><ul>
        <li *ngFor="let msg of line.break2Validation.messages">
          {{msg}}
        </li>
      </ul></ng-template>
    </ng-template>


    <ng-template [ngIf]="!line.break2Validation.isSuccess()"><div style="float:right;"  placement="top" [ngbPopover]='break2' triggers="mouseenter:mouseleave">
      <i class="fa fa-exclamation-triangle"></i>
    </div></ng-template>

    <ng-template #ep2>
      <div [innerHtml] = "explainBreak2()"></div>
    </ng-template>
    <div style="float: left;" placement="top" [ngbPopover]='ep2' triggers="mouseenter:mouseleave">
      <i style="font-size: small;" class="fa fa-info"></i>
    </div>

    <div class="zoomable">
      <div class="hourCell-main">
        - {{retrieveBreak2() | displayMinute}}
      </div>
      <ng-template [ngIf]="hasBreak2Info()"><div class="hourCell-bottom">
        <div class="hourCell-bottom-left">
          {{currentEmployeeHoraire.sdBreak2Start | myDateFormat:'LT'}}
        </div>

        <div class="hourCell-bottom-right">
          {{currentEmployeeHoraire.tsBreak2StartPunchDt | myDateFormat:'LT':'xx:xx'}}-{{currentEmployeeHoraire.tsBreak2EndPunchDt | myDateFormat:'LT':'xx:xx'}}
        </div>
      </div></ng-template>
    </div>
  </div></ng-template>



</div>
